module.exports = __webpack_public_path__ + "img/20200508_180551.a82a7f67.jpg";